// Shared tag color palette + helpers.
// Extracted from Home.tsx so the Home tag dialog and the Settings → Pipeline
// management UI (PipelineTagSettings) draw from the same source of truth.

// Default colors for well-known recommended tag names.
export const TAG_COLORS: Record<string, string> = {
  'Offer Submitted': '#4B90D8',
  'Offer Accepted': '#059669',
  'Under Contract': '#D97706',
  'Deal Closed': '#7C3AED',
  'Passed': '#9CA3AF',
};

// Swatch palette offered in the color pickers.
export const COLOR_PALETTE = [
  '#4B90D8', '#059669', '#D97706', '#7C3AED', '#9CA3AF',
  '#EF4444', '#F97316', '#EAB308', '#22C55E', '#06B6D4',
  '#6366F1', '#EC4899', '#8B5CF6', '#14B8A6',
];

// Resolve a display color for a tag: explicit stored color wins, then a known
// default, then a stable hash-derived hue so every name gets a consistent color.
export const getTagColor = (tagName: string, storedColor?: string | null): string => {
  if (storedColor) return storedColor;
  if (TAG_COLORS[tagName]) return TAG_COLORS[tagName];
  let hash = 0;
  for (let i = 0; i < tagName.length; i++) {
    hash = tagName.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = Math.abs(hash) % 360;
  return `hsl(${hue}, 55%, 50%)`;
};
